export default () =>
  Math.random().toString(32).substring(2, 10) +
  Math.random().toString(32).substring(2, 10)
